export default "__VITE_ASSET__BG82u1zk__"